import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import {
  selectInvalidAddCompany,
  selectInvalidDuplicateAddCompany,
} from '../../store/slice'
import classes from '../index.module.scss'

export const ValidateUpload = ({ invalidFormatFile }) => {
  const invalidTaxCode = useSelector(selectInvalidAddCompany)
  const invalidDuplicateTaxCode = useSelector(selectInvalidDuplicateAddCompany)
  return (
    <>
      {(!!invalidTaxCode?.length ||
        invalidFormatFile ||
        !!invalidDuplicateTaxCode.length) && (
        <Element
          className={classes.validateUpload}
          style={{ backgroundColor: '#F5E6E7', borderColor: '#E0505B' }}
        >
          <div className={classes.validateUploadScroll}>
            <ScrollComponent autoHeight autoHeightMax={60}>
              <Element>
                {invalidFormatFile && (
                  <Element
                    elementName="p"
                    style={{
                      color: '#E0505B',
                      fontStyle: 'italic',
                      padding: '1px 0',
                    }}
                  >
                    <Translate value="library.detailsPortfolios.VALIDATE_FORMAT_FILE" />
                  </Element>
                )}
                {invalidTaxCode?.map((item, index) => (
                  <Element
                    key={index}
                    elementName="p"
                    style={{
                      color: '#E0505B',
                      fontStyle: 'italic',
                      padding: '1px 0',
                    }}
                  >
                    <Translate
                      value="library.detailsPortfolios.VALIDATE_TAX_CODE"
                      taxCode={item}
                    />
                  </Element>
                ))}
                {invalidDuplicateTaxCode?.map((item, index) => (
                  <Element
                    key={index}
                    elementName="p"
                    style={{
                      color: '#E0505B',
                      fontStyle: 'italic',
                      padding: '1px 0',
                    }}
                  >
                    <Translate
                      value="library.detailsPortfolios.VALIDATE_TAX_CODE_DUPLICATE"
                      taxCode={item}
                    />
                  </Element>
                ))}
              </Element>
            </ScrollComponent>
          </div>
        </Element>
      )}
    </>
  )
}
